import api from "./api";

export const GetHomeBanners = async () => {
  return await api.get("HomeBanner").then(res => res.data);
};

export const UploadHomeBanners = async (images) => {
  const formData = new FormData();

  images.forEach((image) => {
    formData.append("images", image);
  });

  return await api.post("HomeBanner", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const DeleteHomeBanner = async (id) => {
  return await api.delete(`HomeBanner/${id}`);
};